import { gtcAddToCart } from 'gtcUtils';
// Custom Product Form

class CustomProductForm extends HTMLElement {
    static openClass = 'custom-quick-add--open';

    constructor() {
        super();
        this.buttonClick = this.buttonClick.bind(this);
        this.toggleForm = this.toggleForm.bind(this);
    }

    connectedCallback() {
        this.dom = {
            form: this.querySelector('form'),
            select: this.querySelector('select'),
            submitButtons: this.querySelectorAll('form button[type="submit"]'),
            variantButtons: this.querySelectorAll('button.block-swatch[type="button"]'),
            openButton: this.querySelector('.custom-quick-add__open-button'),
            closeButton: this.querySelector('.custom-quick-add__close-button')
        };
        this.addEventListeners();
    }

    addEventListeners() {
        this.dom.variantButtons.forEach(variantButton => {
            variantButton.addEventListener('click', this.buttonClick);
        });

        this.dom.openButton.addEventListener('click', this.toggleForm);
        this.dom.closeButton.addEventListener('click', this.toggleForm);
    }

    async buttonClick(event) {
        this.dom.select.value = event.target.value;
        this.classList.remove(CustomProductForm.openClass);

        gtcAddToCart({ variantId: this.dom.select.value, quantity: 1 });
    }

    toggleForm() {
        this.classList.toggle(CustomProductForm.openClass);
    }
}

// if document ready
if (!customElements.get('custom-product-form')) {
    customElements.define('custom-product-form', CustomProductForm);
}